import { render, staticRenderFns } from "./StudentPanel.vue?vue&type=template&id=07151ac8&scoped=true"
import script from "./StudentPanel.vue?vue&type=script&lang=js"
export * from "./StudentPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07151ac8",
  null
  
)

export default component.exports